import React, { useState, useEffect } from "react";
import "./style.css";

import { Modal, Table, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";

import HeavyHeader from "../../components/heavy-header/heavy-header";
import { IoReload } from "react-icons/io5";
import { GoCheckCircleFill } from "react-icons/go";

const Card = ({ piezas, nombre, ubicacion, embarque, turno, handleShow, clientType, credit_client, awb }) => {
  return (
    <div className={`turn-card ${clientType === 1 ? 'bg-top-client' : 'bg-regular-client'}`} onClick={handleShow}>
      <h1>{ubicacion}</h1>
      <h3>{nombre}</h3>
      <p className="turn-static-text"># Turno</p>
      <p className="turn">{turno}</p>
      <p className="awb_cc">No. Tarimas</p>
      <span className="awb_cc_data">{piezas}</span>
      {credit_client && (
        <>
          <p className="awb_cc">AWB</p>
          <span className="awb_cc_data">{awb}</span>
        </>
      )}
    </div>
  );
};

const Weigher = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTurn, setSelectedTurn] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [reloadStatus, setReloadStatus] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const getData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/weighing`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      setData(res.data.data.shipments);
      res.data.data.shipments.length > 0
        ? setReloadStatus(true)
        : setReloadStatus(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleShow = async (id) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/weighing/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setSelectedTurn(res.data.data.shipment);
        reset();
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching turn data", error);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedTurn(null);
    reset();
  };

  const handleConfirm = async (data) => {
    let url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/weighing/update`;
    let method = "post";
    let body = {
      id: data.id,
      quantity_id: data.quantityID,
      weighing_description: data.weighing_description,
      user_id: localStorage.getItem("heavy-load-email"),
      pieces: data.pieces,
    };

    try {
      const res = await axios({
        method,
        url,
        data: body,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });

      if (res.data.code === 1) {
        handleClose();
        getData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    let interval;
    if (!reloadStatus) {
      interval = setInterval(getData, 5000);
    }

    return () => clearInterval(interval);
  }, [reloadStatus]);

  return (
    <>
      <div className="weigher-container">
        <HeavyHeader />
        <div className="weigher-body">
          <div className="weigher-body-title">
            <h1>Pesaje</h1>
            {data.length > 0 && (
              <button onClick={getData}>
                <IoReload /> Actualizar
              </button>
            )}
          </div>
          <div className="weigher-body-turns">
            {loading ? (
              <div className="loading-spinner">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
              </div>
            ) : (
              <div className="weigher-body-turns-cards">
                {data.length > 0 ? (
                  data
                    .slice(0, 32)
                    .map((item, index) => (
                      <Card
                        key={index}
                        embarque={item.tag_number}
                        turno={item.turn_number}
                        piezas={item.number_pallets}
                        nombre={item.consignee}
                        ubicacion={item.destination}
                        handleShow={() => handleShow(item.id)}
                        clientType={item.usert_top}
                        credit_client={item.credit_client}
                        awb={item.awb}
                      />
                    ))
                ) : (
                  <div className="weigher-body-turns-no-found">
                    No hay registros
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {selectedTurn && (
        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          dialogClassName="custom-modal-width-weigher"
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: "#020c41",
              color: "#FFFFFF",
              backgroundImage: "none",
              textAlign: "center",
            }}
          >
            <Modal.Title>Información</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit(handleConfirm)}>
            <Modal.Body>
              <Table
                className="weiger-table"
                bordered
                style={{ textAlign: "center" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text"># de turno</div>
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn?.turn_number}
                        readOnly
                        style={{ border: "none", fontSize: "1.4rem" }}
                      />
                    </td>
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                        padding: "3px",
                      }}
                    >
                      <div className="cont-td-text"># Embarque</div>
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn?.tag_number}
                        readOnly
                        style={{ border: "none", fontSize: "1.4rem" }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#00154F",
                        color: "#FFFFFF",
                      }}
                    >
                      <div className="cont-td-text">Quantity ID</div>
                    </td>
                    <td colSpan="3">
                      <Form.Control
                        type="text"
                        style={{ border: "none" }}
                        {...register("quantityID", {
                          required: "Debes poner un Quantity ID",
                          pattern: {
                            value: /^\d{8,12}$/,
                            message:
                              "El Quantity ID debe tener entre 8 y 12 dígitos y no puede contener letras ni caracteres especiales",
                          },
                        })}
                      />
                      <Form.Control
                        type="hidden"
                        style={{ border: "none" }}
                        value={selectedTurn?.id}
                        {...register("id", {})}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text">Nombre del cliente</div>
                    </td>
                    <td colSpan="3">
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn?.customer_name}
                        readOnly
                        style={{ border: "none" }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text">Destino</div>
                    </td>
                    <td colSpan="3">
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn?.destination}
                        readOnly
                        style={{ border: "none" }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text">Fecha</div>
                    </td>
                    <td colSpan="1">
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn.date.split(" ")[0]}
                        readOnly
                        style={{ border: "none" }}
                      />
                    </td>

                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text">Hora</div>
                    </td>
                    <td colSpan="1">
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn.date.split(" ")[1]}
                        readOnly
                        style={{ border: "none" }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text">Mercancía</div>
                    </td>
                    <td colSpan="3">
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn?.content}
                        readOnly
                        style={{ border: "none" }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text">Piezas Totales</div>
                    </td>

                    {selectedTurn.credit_client && (
                      <>
                        <td colSpan="1">
                          <Form.Control
                            type="number"
                            min="1"
                            style={{
                              border: "none",
                              backgroundColor: "#fff",
                            }}
                            {...register("pieces", {
                              required:
                                "Debes agregar el número de piezas",
                              validate: (value) => Number.isInteger(Number(value)) || "No se permiten números decimales",

                              pattern: {
                                value: /^[1-9][0-9]*$/,
                                message: "El número de piezas debe ser mayor a 0",
                              },

                              min: {
                                value: 1,
                                message: "El número de piezas debe ser mayor a 0",
                              },
                            })}
                          />
                        </td>

                      </>
                    ) || (
                        <>
                          <td colSpan="1">
                            <Form.Control
                              type="text"
                              defaultValue={selectedTurn?.pieces}
                              readOnly
                              style={{ border: "none" }}
                            />
                          </td>
                        </>
                      )}
                    <td
                      style={{
                        backgroundColor: "#a3a3a3",
                        color: "#000000",
                      }}
                    >
                      <div className="cont-td-text td-platforms">
                        Cantidad de tarimas
                      </div>
                    </td>
                    <td colSpan="2">
                      <Form.Control
                        type="text"
                        defaultValue={selectedTurn?.number_pallets}
                        readOnly
                        style={{ border: "none" }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#00154F",
                        color: "#FFFFFF",
                      }}
                    >
                      <div className="cont-td-text td-weigher">
                        Comentarios Pesaje
                      </div>
                    </td>
                    <td colSpan="3">
                      <Form.Control
                        as="textarea"
                        name="weighing_description"
                        id="weighing_description"
                        rows={1}
                        style={{ border: "none" }}
                        {...register("weighing_description", {})}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#00154F",
                        color: "#FFFFFF",
                        padding: "5px",
                      }}
                    >
                      Comentarios Inspector
                    </td>
                    <td
                      colSpan="3"
                      className={
                        selectedTurn.inspection_description
                          ? "td-inspect-comment"
                          : ""
                      }
                    >
                      <p className="inspector-comment">
                        {selectedTurn.inspection_description}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        backgroundColor: "#00154F",
                        color: "#FFFFFF",
                        padding: "5px",
                      }}
                    >
                      Comentarios Administrador
                    </td>
                    <td
                      colSpan="3"
                      className={
                        selectedTurn.admin_description
                          ? "td-inspect-comment"
                          : ""
                      }
                    >
                      <p className="inspector-comment">
                        {selectedTurn.admin_description}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </Table>
              {errors.quantityID && (
                <span
                  style={{
                    color: "red",
                    fontSize: "10px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {errors.quantityID.message}
                </span>
              )}

              {errors.pieces && (
                <span
                  style={{
                    color: "red",
                    fontSize: "10px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {errors.pieces.message}
                </span>
              )}

            </Modal.Body>
            <Modal.Footer>
              <div className="content-btns-input">
                <div className="btns-decision">
                  <button type="submit" className="acept-btn">
                    Aceptar <GoCheckCircleFill />
                  </button>
                </div>
              </div>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default Weigher;
